module.exports = __webpack_public_path__ + "img/chat.33d9b94b.png";